import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { WebsitePageType } from '@models';
import { BaseService, ToastService } from '@services';

@Injectable({
  providedIn: 'root',
})
export class WebsitePageTypeService extends BaseService<WebsitePageType> {
  protected readonly documentPath = 'websitePageTypes';

  constructor(
    protected db: Firestore,
    protected toastService: ToastService
  ) {
    super(db, toastService);
  }
}
